// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".\\+YuJSIHzqViEzJ7GutDaXg\\=\\={position:fixed;width:100%;top:0;z-index:10}", ""]);
// Exports
exports.locals = {
	"mailReadingPaneHeader": "+YuJSIHzqViEzJ7GutDaXg=="
};
module.exports = exports;
